<template>
  <common-modal
    :name="name"
    :primaryAction="primaryAction"
    :secondaryActions="secondaryActions"
    :title="title"
    :onClosed="false"
    height="auto"
    width="70%"
  >
    <template #modal-body>
      <validation-form @on-submit="addGraduationCategory" ref="addForm">
        <md-card class="my-0">
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item d-layout-item md-size-50">
                <validation-field
                  :validations="graduation_category_validation.name"
                  name="name"
                >
                  <label>{{ $t("graduation_category.category_name") }}</label>
                  <md-input
                    required
                    v-model.trim="graduationCategoryInfo.name"
                    :maxlength="graduation_category_validation.name.maxLength"
                  ></md-input>
                  <span class="md-error" v-if="serverValidations.name">{{
                    serverValidations.name
                  }}</span>
                </validation-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <label :for="select.name">{{ $t(select.label) }}</label>
                  <md-select
                    :name="select.name"
                    v-model="graduationCategoryInfo.status"
                    :id="select.name"
                    :multiple="select.multiple"
                  >
                    <md-option
                      v-for="option in select.options"
                      :value="option.id"
                      :key="option.id + option.name"
                      >{{ $t(option.name) }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <label>{{ $t("common.description") }}</label>
                  <md-input
                    class="h-40"
                    v-model.trim="graduationCategoryInfo.description"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <validation-field
                  :validations="graduation_category_validation.subject"
                  name="subject"
                  type="multi-select"
                >
                  <template #default="{ errors }">
                    <label class="subject-label"
                      >{{ $t("common.subject") }}
                      <span style="color:red">*</span></label
                    >
                    <checkbox-multi-select
                      :options="subjects"
                      @filtering="filterSubject($event)"
                      v-model="graduationCategoryInfo.subject_ids"
                      :style="{ marginTop: '-6px' }"
                      :class="{ 'md-invalid': !!errors.length }"
                    >
                    </checkbox-multi-select>
                    <span class="md-error required-subject">
                      {{ errors[0] }}</span
                    >
                  </template>
                </validation-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </validation-form>
    </template>
  </common-modal>
</template>

<script>
import { service_paths } from "@/constants/Services";
import CommonModal from "@/components/Base/CommonModal";
import { genErrMsgOj, Message } from "@/helpers/utils";
import { validations } from "@/validations/graduation_categories";
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import debounce from "lodash/debounce";

export default {
  components: { CommonModal, CheckboxMultiSelect },
  props: ["name", "title"],
  data() {
    return {
      path: service_paths.graduation_categories,
      serverValidations: {},
      graduation_category_validation: validations,
      graduationCategoryInfo: {
        name: null,
        status: "Active",
        description: null,
        subject_ids: []
      },
      accept: false,
      subjects: [],
      subjectOptSelected: [],
      select: {
        label: "common.status",
        name: "status__",
        value: "Active",
        type: "select",
        options: [
          {
            id: "Active",
            name: "common.active"
          },
          {
            id: "Inactive",
            name: "common.inactive"
          }
        ]
      }
    };
  },
  computed: {
    secondaryActions() {
      return [
        {
          title: this.$t("common.cancel"),
          action: this.closeModal
        }
      ];
    },
    primaryAction() {
      return {
        title: this.$t("common.add_new"),
        action: this.doSubmit
      };
    }
  },
  watch: {
    "graduationCategoryInfo.name": function() {
      this.serverValidations.name && delete this.serverValidations.name;
    },
    "graduationCategoryInfo.subject_ids"(newSubject) {
      this.fetchSubjectOptions();
      this.subjectOptSelected = this.subjects.filter(item =>
        newSubject.includes(item.id)
      );
    }
  },

  created() {
    this.fetchSubjectOptions();
  },
  inject: ["reFetchTableData"],
  methods: {
    filterSubject(event) {
      this.debounceSubject(event.text);
    },
    debounceSubject: debounce(function(searchKey) {
      this.fetchSubjectOptions(searchKey);
    }, 1000),
    fetchSubjectOptions(searchKey = "") {
      this.$axios
        .get(
          `${service_paths.subjects}`,
          {
            status: "Active",
            "subject_display_name__~": searchKey,
            limit: 10000
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          let newOptions = data.data.filter(
            item => !this.graduationCategoryInfo.subject_ids.includes(item.id)
          );
          newOptions.map(subject => {
            subject.name = subject.subject_display_name || subject.name;
          });
          this.subjects = [...this.subjectOptSelected, ...newOptions];
        });
    },
    clearData() {
      this.graduationCategoryInfo = Object.assign(this.graduationCategoryInfo, {
        name: null,
        description: null,
        subject_ids: []
      });
    },
    closeModal() {
      this.$modal.hide(this.name);
    },
    async addGraduationCategory() {
      this.$axios
        .post(
          service_paths.graduation_categories,
          this.graduationCategoryInfo,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(async () => {
          this.closeModal();
          await this.reFetchTableData();
          Message.success(this.$t("common.add_success"));
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },
    doSubmit() {
      this.$refs.addForm.submitForm();
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-group {
  padding-top: 5px;
  padding-left: 0px;
  display: flex;
  justify-content: space-between;

  .btn {
    border-radius: 100px;
  }
}

.checkbox {
  font-size: 14px;
}

.md-menu-content.md-select-menu {
  z-index: 10 !important;
}

.md-input {
  width: 230px;
  padding-bottom: 10px !important;
}

.md-layout-item.md-size-50 {
  padding-bottom: 10px;
}

.md-error {
  padding-top: 10px;
  top: 30px !important;
}

.required-subject {
  color: #ff5252;
  font-size: 12px;
}

.subject-label {
  display: block;
  margin-top: 3px;
  margin-bottom: -3px;
  font-size: 11px;
  color: #aaa;
  font-weight: 400;
}

.h-40 {
  height: 41px !important;
}
</style>
